import { ClientPlatform } from "@next-platform/packages-ts-types";
const GLOBAL_THIS = globalThis;
const HAS_REACT_NATIVE_GLOBAL = "nativeCallSyncHook" in GLOBAL_THIS || "__fbBatchedBridge" in GLOBAL_THIS || "nativeFabricUIManager" in GLOBAL_THIS;
const HAS_EXPO_PUBLIC_ENV = typeof process !== "undefined" &&
    process.env !== null &&
    typeof process.env === "object" &&
    Object.keys(process.env).some((key) => key.startsWith("EXPO_PUBLIC_"));
const IS_REACT_NATIVE = (typeof navigator === "object" && navigator !== null && navigator.product === "ReactNative") || HAS_REACT_NATIVE_GLOBAL || HAS_EXPO_PUBLIC_ENV;
export const ANDROID_PLATFORM_OS = "android";
export const IOS_PLATFORM_OS = "ios";
export const WEB_PLATFORM = ClientPlatform.WEB;
export const NATIVE_PLATFORM = ClientPlatform.NATIVE;
export const PLATFORM = IS_REACT_NATIVE ? NATIVE_PLATFORM : WEB_PLATFORM;
export const IS_WEB_PLATFORM = PLATFORM === WEB_PLATFORM;
export const IS_NATIVE_PLATFORM = PLATFORM === NATIVE_PLATFORM;
